module.exports = __webpack_public_path__ + "img/DiNapoli-5.4636481f.jpg";